(() => {
  const instances = new Map();
  function mount(root) {
    if (instances.has(root)) return;
    const slides = [...root.querySelectorAll('[data-carousel-slide]')];
    if (slides.length < 2) return;
    const track = root.querySelector('[data-carousel-track]');
    const controls = root.querySelector('[data-carousel-controls]');
    const dots = [...root.querySelectorAll('[data-carousel-dot]')];
    const status = root.querySelector('[data-carousel-status]');
    const pause = root.querySelector('[data-carousel-pause]');
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const abort = new AbortController();
    const listen = (target, name, handler) => target.addEventListener(name, handler, {signal: abort.signal});
    let index = 0, timer, hovered = false, focused = false, visible = true, paused = false;
    const enabled = root.dataset.autoplay === 'true' && !window.Shopify?.designMode;
    let startPoint, swipedAt = 0;
    const interval = Math.max(5000, Number(root.dataset.interval) || 7000);
    function schedule() {
      clearTimeout(timer);
      if (pause) {
        pause.hidden = !enabled || motion.matches;
        const label = paused ? 'Resume automatic banner rotation' : 'Pause automatic banner rotation';
        pause.setAttribute('aria-label', label); pause.title = label;
        pause.querySelector('[data-carousel-pause-icon]').toggleAttribute('hidden', paused);
        pause.querySelector('[data-carousel-play-icon]').toggleAttribute('hidden', !paused);
      }
      root.dataset.autoplayPaused = String(paused || motion.matches || !enabled);
      if (enabled && !paused && !motion.matches && !hovered && !focused && visible && !document.hidden) timer = setTimeout(() => { show(index + 1, false); }, interval);
    }
    function show(next, manual) {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.inert = i !== index; slide.setAttribute('aria-hidden', String(i !== index)); });
      dots.forEach((dot, i) => { if (i === index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
      track.style.transform = `translateX(-${index * 100}%)`;
      root.dataset.currentSlide = String(index + 1);
      if (manual) status.textContent = slides[index].getAttribute('aria-label');
      schedule();
    }
    listen(root.querySelector('[data-carousel-next]'), 'click', () => show(index + 1, true));
    listen(root.querySelector('[data-carousel-previous]'), 'click', () => show(index - 1, true));
    dots.forEach((dot, i) => listen(dot, 'click', () => show(i, true)));
    if (pause) listen(pause, 'click', () => { paused = !paused; schedule(); });
    listen(root, 'focusin', () => { focused = true; schedule(); });
    listen(root, 'focusout', e => { focused = root.contains(e.relatedTarget); schedule(); });
    listen(root, 'pointerenter', e => { if (e.pointerType === 'mouse') { hovered = true; schedule(); } });
    listen(root, 'pointerleave', () => { hovered = false; schedule(); });
    const viewport = root.querySelector('[data-carousel-viewport]');
    listen(viewport, 'pointerdown', e => { if (e.isPrimary && e.button === 0) startPoint = {x:e.clientX, y:e.clientY}; });
    listen(window, 'pointerup', e => {
      if (!startPoint) return;
      const dx = e.clientX - startPoint.x, dy = e.clientY - startPoint.y;
      startPoint = undefined;
      if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) { swipedAt = Date.now(); show(index + (dx < 0 ? 1 : -1), true); }
    });
    listen(window, 'pointercancel', () => { startPoint = undefined; });
    listen(viewport, 'click', e => { if (Date.now() - swipedAt < 400) e.preventDefault(); });
    listen(document, 'visibilitychange', schedule);
    listen(motion, 'change', schedule);
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); });
    observer.observe(root);
    listen(document, 'shopify:block:select', e => {
      const selected = slides.findIndex(slide => slide.dataset.blockId === e.detail?.blockId);
      if (selected >= 0) show(selected, true);
    });
    root.dataset.ready = 'true'; controls.hidden = false; show(0, false);
    instances.set(root, () => { clearTimeout(timer); abort.abort(); observer.disconnect(); instances.delete(root); });
  }
  function init(scope = document) { scope.querySelectorAll('[data-retail-carousel]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => { for (const [root, dispose] of instances) if (e.target.contains(root)) dispose(); });
})();
